import $ from 'wee-dom';
import $events from 'wee-events';
import $screen from 'wee-screen';
import { RouteHandler } from 'wee-routes';
import { _body } from 'core/variables';

let $formContainer;
let $form;
let $toggle;
let $blogContent;
let $blogFilter;
let $cancelBtn;
let $label;
let $heading;
let $apply;

const setVars = () => {
    $formContainer = $('.blog-filter__container');
    $form = $('.blog-filter__form');
    $toggle = $('.blog-filter__toggle');
    $blogContent = $('.-index');
    $blogFilter = $('.blog-filter');
    $cancelBtn = $('.blog-filter__cancel');
    $label = $('.blog-filter__label');
    $heading = $('.blog-filter__heading');
    $apply = $('.blog-filter__apply');
};

function toggleMobileFilters() {
    $heading.toggleClass('-open');
    $formContainer.toggleClass('-active');
    $(_body).toggleClass('-modal');
}

function toggleDesktopFilters() {
    $heading.toggleClass('-open');
    $formContainer.toggleClass('-active');
}

function toggleMoreFilters() {
    const toggleText = $toggle.text();

    $toggle.toggleClass('-active');
    $toggle.text(toggleText === 'More' ? 'Less' : 'More');
    $form.toggleClass('-expanded');

    $label.each((el, i) => {
        if (i > 4) {
            $label.eq(i).changeTabindex();
        }
    });
}

const start = () => {
    setVars();

    let height = 0;

    $blogContent.each((el) => {
        if ($(el).height() > height) {
            height = $(el).height();
        }
    });

    $blogContent.css('height', `${height}px`);

    $events.on({
        '.blog-filter__heading': {
            click() {
                if ($screen.size() < 4) {
                    toggleMobileFilters();
                }
            },
            keydown(e, el) {
                if ($(el).hasClass('-open') && (e.keyCode === 13 || e.keyCode === 37 || e.keyCode === 38)) {
                    $screen.size() < 4 ? toggleMobileFilters() : toggleDesktopFilters();
                } else if (! $(el).hasClass('-open') && (e.keyCode === 13 || e.keyCode === 39 || e.keyCode === 40)) {
                    $screen.size() < 4 ? toggleMobileFilters() : toggleDesktopFilters();
                }
            },
        },

        '.blog-filter__cancel': {
            click() {
                toggleMobileFilters();
            },
        },

        '.blog-filter__label': {
            click: (e, el) => {
                $(el).toggleClass('-checked');
            },
            keydown: (e, el) => {
                if (e.keyCode === 13 || e.keyCode === 32) {
                    $(el).toggleClass('-checked');
                }
            },
        },

        '.blog-filter__toggle': {
            click() {
                toggleMoreFilters();
            },
            keydown: (e, el) => {
                if ($(el).hasClass('-active') && (e.keyCode === 13 || e.keyCode === 37 || e.keyCode === 38)) {
                    toggleMoreFilters();
                } else if (! $(el).hasClass('-active') && (e.keyCode === 13 || e.keyCode === 39 || e.keyCode === 40)) {
                    toggleMoreFilters();
                }
            },
        },
    });

    $screen.map([
        {
            max: 3,
            callback() {
                if ($formContainer.hasClass('-active')) {
                    toggleDesktopFilters();
                }

                $('.blog-index__top').after($blogFilter);
                $('.blog-filter__form').before($cancelBtn);
            },
        },
        {
            min: 4,
            callback() {
                if ($formContainer.hasClass('-active')) {
                    toggleMobileFilters();
                }

                toggleDesktopFilters();

                $cancelBtn.remove();
                $('.blog-index__container').before($blogFilter);

                if ($(_body).hasClass('-modal')) {
                    $(_body).removeClass('-modal');
                }
            },
        },
    ]);
};

export default new RouteHandler({
    init: start,
    update: start,
});
